import { Link, useLocation } from 'react-router-dom';
import { Home, Briefcase, LayoutDashboard, FileText } from 'lucide-react';
import { useTranslation } from 'react-i18next';
import clsx from 'clsx';

export default function BottomNav() {
  const { t } = useTranslation();
  const { pathname } = useLocation();
  const items = [
    { to: '/',          icon: Home,           label: t('nav.home') },
    { to: '/jobs',      icon: Briefcase,      label: t('nav.jobs') },
    { to: '/dashboard', icon: LayoutDashboard,label: t('nav.dashboard') },
    { to: '/documents', icon: FileText,       label: t('nav.documents') },
  ];
  return (
    <nav className="md:hidden fixed bottom-0 inset-x-0 z-30 bg-white/95 backdrop-blur-md border-t border-gray-100 safe-bottom">
      <div className="grid grid-cols-4">
        {items.map(({ to, icon: Icon, label }) => {
          const active = pathname === to || (to !== '/' && pathname.startsWith(to));
          return (
            <Link
              key={to}
              to={to}
              className={clsx(
                'flex flex-col items-center gap-1 py-2.5 text-xs transition-colors',
                active ? 'text-brand-600' : 'text-gray-500'
              )}
            >
              <Icon className="w-5 h-5" strokeWidth={active ? 2.5 : 2} />
              <span className="font-medium">{label}</span>
            </Link>
          );
        })}
      </div>
    </nav>
  );
}
